<template>
  <lila-default-template :loading-signal-r="loadingSignalR">
    <template #mainContent>
      <div
        class="container patient-ticket-list"
        :class="loadingContent ? 'loading large' : ''"
      >
        <div class="patient-ticket-header">
          <h1 class="title">
            Chamados
          </h1>
        </div>

        <lila-message :alert-data="alert" />

        <div
          v-show="!loadingContent"
          class="columns"
        >
          <div class="column is-narrow patient-sidebar">
            <div class="conversation-list-summary">
              <ul>
                <li class="urgent">
                  ({{ $Utilities.leadingZero(conversationList.urgent.length) }})
                  Urgentes
                </li>
                <li class="moderate">
                  ({{
                    $Utilities.leadingZero(conversationList.moderate.length)
                  }}) Moderada
                </li>
                <li class="low">
                  ({{ $Utilities.leadingZero(conversationList.low.length) }})
                  Baixa
                </li>
              </ul>
            </div>

            <div
              ref="conversationListView"
              class="conversation-list custom-scroll"
              data-tutorial="conversation-list"
            >
              <!-- POC Cuidados Paliativos: para a equipe matricial (role 2),
                   os pedidos de apoio ocupam o lugar do Alerta de Sintomas. -->
              <div
                v-if="isMatrixRole && matrixRequests.length > 0"
                class="conversation-content"
              >
                <div class="conversation-list-header">
                  <p class="conversation-list-title">
                    Pedidos de apoio
                  </p>
                </div>

                <lila-matrix-request-card :data-list="matrixRequests" />
              </div>

              <div
                v-show="!isMatrixRole && data.symptomsAlertList.length > 0"
                class="conversation-content"
              >
                <div class="conversation-list-header">
                  <p class="conversation-list-title">
                    Alerta de Sintomas
                  </p>

                  <div
                    v-show="deletingAllSymptomsAlerts"
                    class="loading very-small"
                  />

                  <button
                    v-show="!deletingAllSymptomsAlerts"
                    class="clear-filter"
                    @click="deleteAllAlert"
                  >
                    Limpar tudo
                  </button>
                </div>

                <lila-diagnostic-card
                  :data-list="data.symptomsAlertList"
                  router-path="patientClinicalEvolution"
                  @custom-click-event="selectPatient"
                  @custom-delete-alert-card="deleteAlert"
                />
              </div>

              <div
                v-show="
                  conversationList.urgent.length > 0 ||
                    conversationList.moderate.length > 0 ||
                    conversationList.low.length > 0
                "
                class="conversation-content"
              >
                <div class="conversation-list-header">
                  <p class="conversation-list-title">
                    Conversas
                  </p>

                  <div
                    v-show="deletingAllTickets"
                    class="loading very-small"
                  />

                  <button
                    v-show="
                      !deletingAllTickets &&
                        conversationList &&
                        (conversationList.urgent.length > 0 ||
                          conversationList.moderate.length > 0 ||
                          conversationList.low.length > 0)
                    "
                    class="clear-filter"
                    @click="deleteAllTickets"
                  >
                    Limpar tudo
                  </button>
                </div>

                <lila-ticket-card
                  :data-list="conversationList.urgent"
                  :selected-patient="data.selectedPatient"
                  router-path="patientChat"
                  @custom-click-event="selectPatient"
                  @custom-delete-ticket-card="deleteTicket"
                />

                <lila-ticket-card
                  :data-list="conversationList.moderate"
                  :selected-patient="data.selectedPatient"
                  router-path="patientChat"
                  @custom-click-event="selectPatient"
                  @custom-delete-ticket-card="deleteTicket"
                />

                <lila-ticket-card
                  :data-list="conversationList.low"
                  :selected-patient="data.selectedPatient"
                  router-path="patientChat"
                  @custom-click-event="selectPatient"
                  @custom-delete-ticket-card="deleteTicket"
                />
              </div>
            </div>
          </div>

          <div class="column patient-column">
            <div
              v-if="pageName == 'patientTickets'"
              class="wait-patient has-text-centered"
            >
              <figure class="image">
                <img :src="require(`@assets/images/doctor.png`)">
              </figure>

              <p>Clique nos chamados ao lado para começar a interagir</p>
            </div>

            <div
              v-else
              ref="patientBox"
              class="patient-box"
            >
              <lila-patient-card-summary
                v-if="data.selectedPatient"
                :patient="data.selectedPatient"
              />

              <div class="menu-patient-card">
                <ul>
                  <li
                    :class="
                      $route.name == 'patientMedicalRecord' ? 'active' : ''
                    "
                  >
                    <router-link :to="{ name: 'patientMedicalRecord' }">
                      Ficha
                    </router-link>
                  </li>
                  <li
                    :class="
                      $route.name == 'patientHistoryRecord' ? 'active' : ''
                    "
                  >
                    <router-link :to="{ name: 'patientHistoryRecord' }">
                      Registros
                    </router-link>
                  </li>
                  <li
                    v-show="userHasPermission(2)"
                    :class="
                      $route.name == 'patientPrescriptions' ? 'active' : ''
                    "
                  >
                    <router-link :to="{ name: 'patientPrescriptions' }">
                      Receita Médica
                    </router-link>
                  </li>
                  <li
                    :class="
                      $route.name == 'patientClinicalEvolution' ? 'active' : ''
                    "
                  >
                    <router-link :to="{ name: 'patientClinicalEvolution' }">
                      Evolução Clínica
                    </router-link>
                  </li>
                  <li :class="$route.name == 'patientChat' ? 'active' : ''">
                    <router-link :to="{ name: 'patientChat' }">
                      Conversa
                    </router-link>
                  </li>
                  <!-- POC Cuidados Paliativos: role 1 simula a equipe assistencial -->
                  <li
                    v-if="isAssistencialRole"
                    :class="$route.name == 'patientMatrixSupport' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientMatrixSupport' }">
                      Solicitar apoio
                    </router-link>
                  </li>
                  <!-- POC Cuidados Paliativos: role 2 simula a equipe matricial -->
                  <li
                    v-if="isMatrixRole"
                    :class="$route.name == 'patientMatrixRequest' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientMatrixRequest' }">
                      Pedido de apoio
                    </router-link>
                  </li>
                  <li
                    v-show="userHasPermission(8)"
                    :class="$route.name == 'patientBarriers' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientBarriers' }">
                      Barreiras
                    </router-link>
                  </li>
                  <li
                    v-if="hasAccessToActionFeature()"
                    :class="$route.name == 'patientActions' ? 'active' : ''"
                  >
                    <router-link
                      :to="{
                        name: 'patientActions',
                        id: data.selectedPatient ? data.selectedPatient.id : ''
                      }"
                    >
                      Ações
                    </router-link>
                  </li>
                  <li
                    :class="
                      $route.name == 'patientClosedMessages' ? 'active' : ''
                    "
                  >
                    <router-link :to="{ name: 'patientClosedMessages' }">
                      Chamados Encerrados
                    </router-link>
                  </li>
                  <li
                    :class="$route.name == 'patientAttachments' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientAttachments' }">
                      Anexos
                    </router-link>
                  </li>
                  <li
                    v-if="userHasPermission(13)"
                    :class="$route.name == 'patientTeleconsultas' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientTeleconsultas' }">
                      Teleconsultas
                    </router-link>
                  </li>
                  <li
                    v-if="canManage"
                    :class="$route.name == 'patientManagement' ? 'active' : ''"
                  >
                    <router-link :to="{ name: 'patientManagement' }">
                      Gestão
                    </router-link>
                  </li>
                </ul>
              </div>

              <router-view
                :closed-ticket-id="closedTicketId"
                :new-message-for-patient="newMessageForPatient"
                @update-ticket-priority="updateTicketPriority"
                @remove-ticket="removeTicket"
                @update-ticket-message="updateTicketMessage"
                @update-patient-card-summary="updatePatientCardSummary"
                @update-patient-ticket-card="updatePatientTicketCard"
                @update-patient-symptom-alert-card="
                  updatePatientSymptomAlertCard
                "
                @update-patient-team="updatePatientTeam"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </lila-default-template>
</template>

<script>
import DefaultTemplate from "@components/template/DefaultTemplate.vue";
import TicketCard from "@components/shared/lila/TicketCard.vue";
import DiagnosticCard from "@components/shared/lila/DiagnosticCard.vue";
import PatientCardSummary from "@components/shared/lila/PatientCardSummary.vue";
import MatrixRequestCard from "@components/shared/lila/MatrixRequestCard.vue";
import { listMatrixRequests } from "@/services/palliative/matrixSupportApi";
import { pocLiveSync } from "@/services/palliative/pocLiveSync";
import Message from "@components/shared/message/Message.vue";
import { Utilities } from "../../plugins/Utilities.js";
import decodeToken from "../../js/decodeToken.js";
import { eventBus } from "../../eventBus";
import { onMounted, onBeforeUnmount, reactive, provide, ref } from "vue";

require("@microsoft/signalr");

export default {
  components: {
    "lila-ticket-card": TicketCard,
    "lila-diagnostic-card": DiagnosticCard,
    "lila-patient-card-summary": PatientCardSummary,
    "lila-matrix-request-card": MatrixRequestCard,
    "lila-message": Message,
    "lila-default-template": DefaultTemplate
  },
  // POC Cuidados Paliativos: pedidos de apoio chegam ao vivo da aba da role 1.
  mixins: [pocLiveSync("reloadMatrixRequests")],
  setup() {
    const alert = ref({
      message: "",
      type: "",
      show: false
    });

    const conversationList = reactive({
      urgent: [],
      moderate: [],
      low: []
    });

    provide("alert-message", alert);

    const removeTicket = (patientId) => {
      const normalizedId = String(patientId ?? "");
      let removed = false;

      for (const priority of ["urgent", "moderate", "low"]) {
        const list = conversationList[priority] || [];
        const novaLista = list.filter((item) => {
          const itemId = String(item.id ?? item.Id ?? "");
          const itemTicketId = String(item.ticketId ?? item.TicketId ?? "");
          return !(itemId === normalizedId || itemTicketId === normalizedId);
        });

        if (novaLista.length < list.length) {
          conversationList[priority] = novaLista;
          removed = true;

          break;
        }
      }

      return removed;
    };

    const getTicket = (patientId) => {
      let index = null;
      let ticket = null;

      ["urgent", "moderate", "low"].forEach((priority) => {
        index = conversationList[priority]
          .map((item) => item.id)
          .indexOf(parseInt(patientId));

        if (index !== -1) {
          ticket = conversationList[priority].splice(index, 1)[0];
        }
      });
      return ticket;
    };

    function getPatientUrgency(urgency) {
      switch (urgency) {
        case "High":
          return "urgent";

        case "Normal":
          return "moderate";

        case "Low":
          return "low";
      }
    }

    function updateTicketPriority(payload) {
      const priority = getPatientUrgency(payload.priority);

      const ticket = getTicket(payload.patientId);
      if (!ticket || !ticket[0]) return;

      ticket[0].urgency = priority;

      conversationList[priority].push(ticket[0]);
    }

    const removeTicketByPatientId = (patientId) => {
      getTicket(patientId);
    };

    // Encontra card pelo ticketId em TODAS as prioridades (sem remover)
    const findCardByTicketId = (ticketId) => {
      const normalizedTicketId = Number(ticketId);
      for (const priority of ["urgent", "moderate", "low"]) {
        const list = conversationList[priority] || [];
        const index = list.findIndex(
          (item) => Number(item.ticketId) === normalizedTicketId
        );
        if (index !== -1) {
          return { card: list[index], priority, index };
        }
      }
      return null;
    };

    const updateCardLocally = (messageData) => {
      const result = findCardByTicketId(messageData.ticketId);
      if (!result) return false;

      const { card, priority, index } = result;
      const newPriority = getPatientUrgency(messageData.patientPriority);

      card.message = messageData.attachedDocument
        ? "[um arquivo foi enviado]"
        : messageData.message;

      const date = new Date(messageData.dateAndTime);
      card.date = `${date.toLocaleDateString("pt-BR")} - ${date.toLocaleTimeString("pt-BR")}`;

      if (messageData.origin === "Patient") {
        card.amountMessage = (parseInt(card.amountMessage) || 0) + 1;
      }

      conversationList[priority].splice(index, 1);

      const targetPriority = newPriority || priority;
      conversationList[targetPriority].unshift(card);

      return true;
    };

    const updateCardFromProfessional = (chat, message) => {
      const ticketId = chat.id || chat.Id;
      const result = findCardByTicketId(ticketId);
      if (!result) return false;

      const { card, priority, index } = result;
      const newPriority = getPatientUrgency(chat.doctorPriority);

      card.message = message.attachedDocument
        ? "[um arquivo foi enviado]"
        : message.message;

      const date = new Date(message.dateAndTime);
      card.date = `${date.toLocaleDateString("pt-BR")} - ${date.toLocaleTimeString("pt-BR")}`;

      card.amountMessage = "";

      conversationList[priority].splice(index, 1);

      const targetPriority = newPriority || priority;
      conversationList[targetPriority].unshift(card);

      return true;
    };

    let updateTicketPriorityHandler = null;

    onMounted(() => {
      eventBus.on("removeTicket", removeTicketByPatientId);
      updateTicketPriorityHandler = (payload) => updateTicketPriority(payload);
      eventBus.on("updateTicketPriority", updateTicketPriorityHandler);
    });

    onBeforeUnmount(() => {
      eventBus.off("removeTicket", removeTicketByPatientId);

      if (updateTicketPriorityHandler) {
        eventBus.off("updateTicketPriority", updateTicketPriorityHandler);
      }
    });

    return {
      alert,
      getTicket,
      getPatientUrgency,
      removeTicket,
      conversationList,
      updateTicketPriority,
      findCardByTicketId,
      updateCardLocally,
      updateCardFromProfessional
    };
  },

  data() {
    return {
      userId: null,
      // POC Cuidados Paliativos: pedidos de apoio salvos no navegador.
      matrixRequests: [],
      data: {
        symptomsAlertList: [],
        selectedPatient: null
      },
      pageName: this.$route.name,
      ticketMessageSignalR: {
        active: false,
        connection: null,
        timeout: false,
        retryCount: 0
      },
      symptomSignalR: {
        active: false,
        connection: null,
        timeout: false,
        retryCount: 0
      },
      ticketTransferSignalR: {
        active: false,
        connection: null,
        timeout: false,
        retryCount: 0
      },
      signalRTimeout: 0,
      signalRMaxRetry: 3,
      loading: false,
      loadingContent: false,
      loadingSignalR: false,
      deletingAllTickets: false,
      deletingAllSymptomsAlerts: false,
      patientColumnHeight: 0,
      patientColumnHeightInterval: null,
      closedTicketId: null,
      newMessageForPatient: {}
    };
  },

  computed: {
    canManage() {
      return this.$Utilities.hasManagementAccess(this);
    },
    // POC Cuidados Paliativos: role 1 (UnitAdmin) simula a equipe assistencial.
    isAssistencialRole() {
      return this.$Utilities.isPalliativeAssistencialTeam(this);
    },
    // POC Cuidados Paliativos: role 2 (InstitutionAdmin) simula a equipe matricial.
    isMatrixRole() {
      return this.$Utilities.isPalliativeMatrixTeam(this);
    }
  },
  watch: {
    $route(to) {
      this.pageName = to.name;
      if (this.pageName == "patientTickets") this.data.selectedPatient = null;
    }
  },
  created() {
    this.userId = this.$Session.get(this.$userSessionName).professional.Id;

    this.getContent();
    this.reloadMatrixRequests();
  },
  async mounted() {
    this.controlSidebarHeight();
    this.controlSidebarHeight();

    await this.startTicketMessageSignalR();

    this.startSymptomSignalR();
    this.startTicketTransferSignalR();
  },
  beforeUnmount() {
    clearInterval(this.patientColumnHeightInterval);

    this.closeSignalRConnections();
  },

  methods: {
    // POC Cuidados Paliativos: pedidos de apoio, só para a equipe matricial.
    async reloadMatrixRequests() {
      if (!this.isMatrixRole) return;
      try {
        this.matrixRequests = await listMatrixRequests();
      } catch (error) {
        console.error("POC Cuidados Paliativos: não foi possível carregar os pedidos de apoio.", error);
      }
    },
    closeActiveChat(eventData) {
      const selectedPatient = this.data.selectedPatient;
      if (!selectedPatient) return;

      const eventPatientId = String(
        typeof eventData === "object"
          ? (eventData?.patient?.id ??
              eventData?.patientId ??
              eventData?.fromId ??
              "")
          : (eventData ?? "")
      );

      const eventTicketId = String(
        typeof eventData === "object"
          ? (eventData?.ticketId ??
              eventData?.TicketId ??
              eventData?.id ??
              eventData?.Id ??
              "")
          : (eventData ?? "")
      );

      const selectedPatientId = String(
        selectedPatient?.id ?? selectedPatient?.patientId ?? ""
      );
      const selectedTicketId = String(selectedPatient?.ticketId ?? "");

      const isSamePatient =
        eventPatientId &&
        selectedPatientId &&
        eventPatientId === selectedPatientId;
      const isSameTicket =
        eventTicketId && selectedTicketId && eventTicketId === selectedTicketId;

      if (isSamePatient || isSameTicket) {
        this.data.selectedPatient = null;
      }
    },

    getContent() {
      this.loadingContent = true;

      Promise.all([
        this.getPatientTicketList(),
        this.getPatientSymptomsAlertList()
      ]).finally(() => (this.loadingContent = false));
    },

    async getPatientTicketList() {
      const ticketUrl = "api/ticket/professional";
      const requestId = (this.ticketListRequestId =
        (this.ticketListRequestId || 0) + 1);

      try {
        const { data } = await this.$axios.get(ticketUrl, {
          headers: {
            Authorization: `Bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        });

        if (requestId !== this.ticketListRequestId) return;

        this.conversationList.urgent = this.mountCardList(data?.High ?? []);
        this.conversationList.moderate = this.mountCardList(data?.Normal ?? []);
        this.conversationList.low = this.mountCardList(data?.Low ?? []);

        if (this.$route.params.id) {
          await this.getSelectedPatient(this.$route.params.id);

          if (!this.data.selectedPatient) {
            this.$router.push({ name: "patientTickets" });
          }
        }
      } catch (error) {
        console.error(error);

        const status = error?.response?.status;
        const responseData = error?.response?.data;

        if (status) {
          this.$Utilities.verifyToken(status);
        }

        this.$Utilities.controlAlert(
          responseData || "Erro ao buscar tickets",
          this.alert,
          "danger"
        );
      }
    },

    mountCard(ticket) {
      let patient = this.$Utilities.getValueIgnoreCase(ticket, "patient");
      let messages = this.$Utilities.getValueIgnoreCase(ticket, "messages");

      return {
        id: this.$Utilities.getValueIgnoreCase(patient, "id"),
        ticketId: this.$Utilities.getValueIgnoreCase(ticket, "id"),
        messagesIdList:
          this.$Utilities.getValueIgnoreCase(ticket, "messages") != null
            ? this.$Utilities
                .getValueIgnoreCase(ticket, "messages")
                .map((item) => this.$Utilities.getValueIgnoreCase(item, "id"))
            : [],
        name: this.$Utilities.getValueIgnoreCase(patient, "name"),
        profilePicture: this.$Utilities.getValueIgnoreCase(patient, "photo")
          ? this.$Utilities.getValueIgnoreCase(patient, "photo")
          : this.$Utilities.getDefaultProfilePicture(
              this.$Utilities.getValueIgnoreCase(patient, "gender")
            ),
        cid:
          this.$Utilities.getPatientCid(patient) == null
            ? ""
            : this.$Utilities.getPatientCid(patient),
        gender: this.$Utilities.getValueIgnoreCase(patient, "gender"),
        birthDate: this.$Utilities.getValueIgnoreCase(patient, "birthDate"),
        painLevel: "",
        message: this.$Utilities.getValueIgnoreCase(
          messages[messages.length - 1],
          "AttachedDocument"
        )
          ? "[um arquivo foi enviado]"
          : this.$Utilities.getValueIgnoreCase(
              messages[messages.length - 1],
              "message"
            ),
        amountMessage:
          messages.filter(
            (i) => this.$Utilities.getValueIgnoreCase(i, "origin") == "Patient"
          ).length > 0
            ? messages.filter(
                (i) =>
                  this.$Utilities.getValueIgnoreCase(i, "origin") == "Patient"
              ).length
            : "",
        doctorPriority: this.getPatientUrgency(
          this.$Utilities.getValueIgnoreCase(ticket, "doctorPriority")
        ),
        date: messages[messages.length - 1]
          ? this.$Utilities.formatDateWithTime(
              this.$Utilities.getValueIgnoreCase(
                messages[messages.length - 1],
                "DateAndTime"
              ),
              "YYYY-MM-DDTHH:mm:ss",
              "DD/MM/YYYY - HH:mm:ss"
            )
          : "",
        imgLoaded: false,
        deletingTicket: false,
        RegisterNumber: this.$Utilities.getValueIgnoreCase(
          patient,
          "RegisterNumber"
        )
      };
    },

    mountCardList(ticketList) {
      return ticketList.map((item) => {
        return this.mountCard(item);
      });
    },

    createTicketMessage(ticket) {
      let priority = this.getPatientUrgency(
        this.$Utilities.getValueIgnoreCase(ticket, "doctorPriority")
      );
      let card = this.mountCard(ticket);
      this.conversationList[priority].push(card);
    },

    getPatientSymptomsAlertList() {
      return this.$axios
        .get("/api/ticket/symptoms", {
          headers: {
            Authorization: `bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        })
        .then((res) => {
          this.data.symptomsAlertList = [];
          this.createSymptomAlerts(res.data);
        })
        .catch((error) => {
          this.$Utilities.verifyToken(error.response.status);
          this.$Utilities.controlAlert(
            error.response.data,
            this.alert,
            "danger"
          );
        });
    },

    getPatientPain(patientId) {
      this.$axios
        .get(`/api/clinicalevolution/pain/patient/${patientId}`, {
          headers: {
            Authorization: `bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        })
        .then((res) => {
          if (res.data)
            this.data.selectedPatient.painLevel = `EVA ${res.data.Evolutions[0].Intensity}`;
        })
        .catch((error) => {
          this.$Utilities.verifyToken(error.response.status);
        })
        .finally(() => (this.loadingContent = false));
    },
    deleteAlert(alert) {
      let alertList = [];

      alertList.push({
        id: alert.alertId
      });

      this.deleteSymptomAlert(alertList);
    },
    deleteAllAlert() {
      let alertList = [];

      this.data.symptomsAlertList.forEach((item) => {
        alertList.push({
          id: item.alertId
        });
      });

      this.deleteSymptomAlert(alertList);
    },
    removeAlert(alertId) {
      let index = this.data.symptomsAlertList
        .map((item) => item.alertId)
        .indexOf(parseInt(alertId));

      if (index != -1) this.data.symptomsAlertList.splice(index, 1);
    },
    deleteSymptomAlert(alertList) {
      let alertListArray = alertList.map((item) => item.id);

      this.deletingAllSymptomsAlerts = true;

      for (let index in this.data.symptomsAlertList) {
        if (
          alertListArray.indexOf(this.data.symptomsAlertList[index].alertId) !=
          -1
        )
          this.data.symptomsAlertList[index].deletingAlert = true;
      }

      this.$axios({
        method: "PUT",
        url: "/api/ticket/symptoms",
        data: alertList,
        headers: {
          Authorization: `bearer ${
            this.$Session.get(this.$userSessionName).token.Value
          }`
        }
      })
        .catch((error) => {
          this.$Utilities.verifyToken(error.response.status);
          this.$Utilities.controlAlert(
            error.response.data,
            this.alert,
            "danger"
          );
        })
        .finally(() => {
          alertList.forEach((item) => this.removeAlert(item.id));

          this.deletingAllSymptomsAlerts = false;
        });
    },

    async deleteMessageTicket(ticketList) {
      ticketList.forEach((item) => {
        ["urgent", "moderate", "low"].forEach((priority) => {
          this.conversationList[priority].forEach((ticket) => {
            if (ticket.id === item.patientId) ticket.deletingTicket = true;
          });
        });
      });

      try {
        await this.$axios.put("/api/ticket", ticketList, {
          headers: {
            Authorization: `bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        });

        ["urgent", "moderate", "low"].forEach((priority) => {
          this.conversationList[priority] = this.conversationList[
            priority
          ].filter(
            (ticket) => !ticketList.some((item) => item.patientId === ticket.id)
          );
        });
      } catch (error) {
        this.$Utilities.verifyToken(error.response?.status);
        this.$Utilities.controlAlert(
          error.response?.data,
          this.alert,
          "danger"
        );
      } finally {
        this.deletingAllTickets = false;
      }
    },

    deleteTicket(patient) {
      let ticket = null;

      for (const priority of ["urgent", "moderate", "low"]) {
        const found = this.conversationList[priority].find(
          (t) => t.id === Number(patient.id)
        );
        if (found) {
          ticket = found;
          break;
        }
      }
      if (!ticket || !ticket.messagesIdList) return;
      const ticketList = ticket.messagesIdList.map((messageId) => ({
        id: messageId,
        patientId: patient.id
      }));

      this.deleteMessageTicket(ticketList);
    },

    async deleteAllTickets() {
      if (
        !this.conversationList.urgent.length &&
        !this.conversationList.moderate.length &&
        !this.conversationList.low.length
      )
        return;

      this.deletingAllTickets = true;

      const ticketList = [];

      ["urgent", "moderate", "low"].forEach((priority) => {
        this.conversationList[priority].forEach((ticket) => {
          ticket.messagesIdList.forEach((messageId) => {
            ticketList.push({
              id: messageId,
              patientId: ticket.id
            });
          });
        });
      });

      await this.deleteMessageTicket(ticketList);
    },

    selectPatient(patient) {
      let selectedPatient = Object.assign({}, patient);

      if (
        this.data.selectedPatient &&
        this.data.selectedPatient.profilePicture ==
          selectedPatient.profilePicture
      ) {
        selectedPatient.imgLoaded = true;
      }

      this.data.selectedPatient = selectedPatient;

      this.getPatientPain(this.data.selectedPatient.id);
    },
    getSelectedPatient(patientId) {
      let patient = null;

      ["urgent", "moderate", "low"].forEach((index) => {
        patient = this.conversationList[index].filter(
          (item) => item.id == patientId
        );

        if (patient.length > 0) this.selectPatient(patient[0]);
      });
    },

    updateTicketMessage(priority, patientId, message, date, ticket) {
      priority = this.getPatientUrgency(priority);

      let card = this.criarOuRecuperarCard(
        patientId,
        ticket,
        message,
        priority
      );
      if (!card || !card[0]) {
        return;
      }
      if (message.origin == 2 || message.origin.toUpperCase() == "PROFESSIONAL")
        card[0].amountMessage = "";

      card[0].message = message.message;
      card[0].date = this.$Utilities.formatDateWithTime(
        date,
        "YYYY-MM-DDTHH:mm:ss",
        "DD/MM/YYYY - HH:mm:ss"
      );
      card[0].messagesIdList.push(
        this.$Utilities.getValueIgnoreCase(message, "id")
      );

      this.conversationList[priority].push(card[0]);
    },

    updatePatientTeam(payload) {
      if (!this.data.selectedPatient) return;
      this.data.selectedPatient.doctor =
        payload && payload.teamName ? payload.teamName : "";
    },

    updatePatientCardSummary(patient) {
      this.data.selectedPatient.name = patient.name || patient.Name;
      this.data.selectedPatient.cid = Utilities.getSelectedPatientCid(patient);
      ((this.data.selectedPatient.gender = patient.gender || patient.Gender),
        (this.data.selectedPatient.birthDate =
          patient.birthdate || patient.BirthDate
            ? this.$Utilities.formatDate(
                patient.birthdate || patient.BirthDate,
                "DD/MM/YYYY",
                "MM/DD/YYYY"
              )
            : ""));

      this.data.selectedPatient.diagnostic =
        patient.diagnostic | patient.Diagnostic;
    },
    updatePatientTicketCard(patient) {
      let priorities = ["urgent", "moderate", "low"];

      for (let priority of priorities) {
        for (let ticket of this.conversationList[priority]) {
          if (ticket.id == this.data.selectedPatient.id) {
            ticket.name = patient.Name;
            ticket.cid = Utilities.getSelectedPatientCid(patient);
            ticket.gender = patient.Gender;
            ticket.birthDate = patient.BirthDate
              ? this.$Utilities.formatDate(
                  patient.BirthDate,
                  "DD/MM/YYYY",
                  "MM/DD/YYYY"
                )
              : "";
            break;
          }
        }
      }
    },
    updatePatientSymptomAlertCard(patient) {
      for (let alert of this.data.symptomsAlertList) {
        if (alert.id == this.data.selectedPatient.id) {
          alert.name = patient.Name;
          alert.cid = Utilities.getSelectedPatientCid(patient);
          alert.gender = patient.Gender;
          alert.birthDate = patient.BirthDate
            ? this.$Utilities.formatDate(
                patient.BirthDate,
                "DD/MM/YYYY",
                "MM/DD/YYYY"
              )
            : "";
        }
      }
    },

    criarOuRecuperarCard(patientId, chat, message, priority) {
      const existing = this.conversationList[priority].find(
        (item) => item.id === parseInt(patientId)
      );
      if (!existing) {
        return [this.mountCard(chat, message)];
      } else {
        const card = this.getTicket(patientId);
        return card ? [card] : [];
      }
    },

    getPatientUrgencyByNumber(number) {
      switch (number) {
        case 0:
          return "urgent";

        case 1:
          return "moderate";

        case 2:
          return "low";
      }
    },
    userHasPermission(feature) {
      const decodedToken = decodeToken(
        this.$Session.get(this.$userSessionName).token.Value
      );
      return decodedToken && decodedToken.FeaturesId.includes(feature);
    },

    async startTicketMessageSignalR() {
      try {
        if (this.ticketMessageSignalR.connection != null) return true;

        this.ticketMessageSignalR.connection =
          await this.$SignalRConnector.startSignalR(
            "messageprofessionalhub",
            (connection) => {
              this.startTicketMessageSignalRListeners(connection);
            },
            this.signalRTimeout,
            String(this.userId),
            "patientTicketList"
          );
      } catch (erro) {
        if (this.ticketMessageSignalR.retryCount < this.signalRMaxRetry) {
          ++this.ticketMessageSignalR.retryCount;
          await this.startTicketMessageSignalR();
        }
      }
    },
    async refreshUntilTicketAppears(ticketId, maxAttempts = 4, delayMs = 1500) {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        if (attempt > 0) {
          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }

        await this.getPatientTicketList();

        if (!ticketId || this.findCardByTicketId(ticketId)) return;
      }
    },
    async startTicketMessageSignalRListeners(connection) {
      connection.on("PatientMessage", (res) => {
        this.loadingSignalR = true;
        this.newMessageForPatient = {
          patientId: res.fromId,
          ticketId: res.ticketId
        };

        const updated = this.updateCardLocally(res);

        if (!updated) {
          this.refreshUntilTicketAppears(res.ticketId);
        }

        this.loadingSignalR = false;
      });

      connection.on("ChatClosed", async (res) => {
        this.loadingSignalR = true;

        try {
          const { id: patientId } = res.patient || {};
          const { ticketId } = res;

          this.closeActiveChat(res);

          const removed =
            this.removeTicket(patientId) || this.removeTicket(ticketId);
          if (!removed) await this.getPatientTicketList();
        } finally {
          this.loadingSignalR = false;
        }
      });

      connection.on("ProfessionalMessage", (chat, message) => {
        this.loadingSignalR = true;

        // Tenta atualizar localmente primeiro (instantâneo)
        const updated = this.updateCardFromProfessional(chat, message);

        // Se não encontrou o card, usa função antiga (fallback)
        if (!updated) {
          this.updateTicketMessage(
            chat.doctorPriority,
            chat.patient.id,
            message,
            message.dateAndTime,
            chat
          );
        }

        this.loadingSignalR = false;
      });
    },

    async startSymptomSignalR() {
      try {
        if (this.symptomSignalR.connection != null) return true;

        this.symptomSignalR.connection = await this.$SignalRConnector.startSignalR(
          "symptomhub",
          (connection) => {
            this.startSymptomSignalRListeners(connection);
          },
          this.signalRTimeout,
          String(this.userId),
          "patientTicketList"
        );
      } catch (erro) {
        console.log("Erro na comunicação com o SignalR: " + erro);
        if (this.symptomSignalR.retryCount < this.signalRMaxRetry) {
          ++this.symptomSignalR.retryCount;

          const delay = this.symptomSignalR.retryCount * 2000;
          await new Promise(resolve => setTimeout(resolve, delay));
          await this.startSymptomSignalR();
        }
      }
    },

    async startSymptomSignalRListeners(connection) {
      connection.on("SymptomAlert", () => {
        this.loadingSignalR = true;

        this.$axios
          .all([this.getPatientSymptomsAlertList()])
          .finally(() => (this.loadingSignalR = false));
      });
    },

    async startTicketTransferSignalR() {
      try {
        if (this.ticketTransferSignalR.connection != null) return true;

        this.ticketTransferSignalR.connection =
          await this.$SignalRConnector.startSignalR(
            "tickettransferhub",
            (connection) => {
              this.startTransferSignalRListeners(connection);
            },
            this.signalRTimeout,
            String(this.userId),
            "patientTicketList"
          );
      } catch (erro) {
        console.log("Erro na comunicação com o SignalR: " + erro);
        if (this.ticketTransferSignalR.retryCount < this.signalRMaxRetry) {
          ++this.ticketTransferSignalR.retryCount;

          const delay = this.ticketTransferSignalR.retryCount * 2000;
          await new Promise(resolve => setTimeout(resolve, delay));
          await this.startTicketTransferSignalR();
        }
      }
    },

    async startTransferSignalRListeners(connection) {
      connection.on("TicketHandedOff", (transferMessage) => {
        this.loadingSignalR = true;

        let ticket = this.$Utilities.getValueIgnoreCase(
          transferMessage,
          "ticket"
        );
        let patient = this.$Utilities.getValueIgnoreCase(ticket, "patient");

        this.removeTicket(this.$Utilities.getValueIgnoreCase(patient, "id"));

        this.loadingSignalR = false;
      });

      connection.on("TicketReceived", (transferMessage) => {
        this.loadingSignalR = true;

        let ticket = transferMessage.ticket;
        this.createTicketMessage(ticket);

        let clinicalEvolutions = transferMessage.symptoms;
        clinicalEvolutions.forEach((clinicalEvolution) => {
          this.createSymptomAlertsForPatient(clinicalEvolution, ticket.patient);
        });

        this.loadingSignalR = false;
      });
    },

    closeSignalRConnections() {
      if (this.ticketMessageSignalR.timeout != null)
        clearTimeout(this.ticketMessageSignalR.timeout);
      if (this.symptomSignalR.timeout != null)
        clearTimeout(this.symptomSignalR.timeout);
      if (this.ticketTransferSignalR.timeout != null)
        clearTimeout(this.ticketTransferSignalR.timeout);

      this.$SignalRConnector.stopSignalR(
        this.ticketMessageSignalR.connection,
        "patientTicketList"
      );
      this.$SignalRConnector.stopSignalR(
        this.symptomSignalR.connection,
        "patientTicketList"
      );
      this.$SignalRConnector.stopSignalR(
        this.ticketTransferSignalR.connection,
        "patientTicketList"
      );

      this.ticketMessageSignalR.active = false;
      this.symptomSignalR.active = false;
      this.ticketTransferSignalR.active = false;
    },

    createSymptomAlerts(clinicalEvolutions) {
      clinicalEvolutions.forEach((item) => {
        this.createSymptomAlertsForPatient(
          item,
          this.$Utilities.getValueIgnoreCase(item, "patient")
        );
      });
    },

    createSymptomAlertsForPatient(clinicalEvolution, patient) {
      let evolutions = this.$Utilities.getValueIgnoreCase(
        clinicalEvolution,
        "evolutions"
      );
      let patientPhoto =
        this.$Utilities.getValueIgnoreCase(patient, "photo") != null &&
        this.$Utilities.getValueIgnoreCase(patient, "photo") != undefined
          ? this.$Utilities.getValueIgnoreCase(patient, "photo")
          : this.$Utilities.getDefaultProfilePicture(
              this.$Utilities.getValueIgnoreCase(patient, "gender")
            );

      evolutions.forEach((evolution) => {
        let symptom = this.$Utilities.getValueIgnoreCase(evolution, "symptom");
        this.data.symptomsAlertList.push({
          id: this.$Utilities.getValueIgnoreCase(patient, "id"),
          alertId: this.$Utilities.getValueIgnoreCase(evolution, "id"),
          name: this.$Utilities.getValueIgnoreCase(patient, "name"),
          profilePicture: patientPhoto,
          registerNumber: this.$Utilities.getValueIgnoreCase(
            patient,
            "registerNumber"
          ),
          cid: this.$Utilities.getPatientCid(patient),
          gender: this.$Utilities.getValueIgnoreCase(patient, "gender"),
          birthDate: this.$Utilities.getValueIgnoreCase(patient, "birthDate"),
          painLevel: "",
          diagnostic: {
            isEva: this.$Utilities.getValueIgnoreCase(symptom, "isEva"),
            name: this.$Utilities.getValueIgnoreCase(symptom, "name"),
            intensity: this.$Utilities.getValueIgnoreCase(
              evolution,
              "intensity"
            )
          },
          date: this.$Utilities.formatDateWithTime(
            this.$Utilities.getValueIgnoreCase(
              clinicalEvolution,
              "dateAndTime"
            ),
            "YYYY-MM-DDTHH:mm:ss",
            "DD/MM/YYYY HH:mm"
          ),
          imgLoaded: false,
          deletingAlert: false,
          doctor: ""
        });
      });
    },

    controlSidebarHeight() {
      this.patientColumnHeightInterval = setInterval(
        ($this) => {
          if (!$this.$refs.patientBox) return null;
          if (
            typeof $this.$refs.patientBox !== "undefined" &&
            $this.patientColumnHeight != $this.$refs.patientBox.offsetHeight
          ) {
            $this.patientColumnHeight = $this.$refs.patientBox.offsetHeight;
            $this.$refs.conversationListView.style.height = `${
              $this.patientColumnHeight - 50
            }px`;
          }
        },
        500,
        this
      );
    },
    reloadTicketList() {
      this.getContent();
    },

    hasAccessToActionFeature() {
      return this.$Utilities.hasAccessToFeature(this, 7);
    }
  }
};
</script>

<style>
@import "~@assets/css/components/patientTickets.css";
@import "~@assets/css/views/patientTickets.css";

.patient-ticket-list .columns {
  display: flex;
}

.patient-ticket-list .patient-sidebar {
  flex: 1;
  max-width: 400px;
}

.patient-ticket-list .patient-column {
  flex: 2;
  min-width: 300px;
}
</style>
